import { render, staticRenderFns } from "./ResultPage.vue?vue&type=template&id=f9fb935a&scoped=true"
import script from "./ResultPage.vue?vue&type=script&lang=js"
export * from "./ResultPage.vue?vue&type=script&lang=js"
import style0 from "./ResultPage.vue?vue&type=style&index=0&id=f9fb935a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9fb935a",
  null
  
)

export default component.exports